// import React from 'react'
const AuthMiddleware = ({ auths, code, children }) =>  {
  if (!Array.isArray(auths)) {
    console.error('AuthMiddleware：数据格式错误')
    return null
  }
  return auths.includes(code) ? children : null
}
export default AuthMiddleware